import PaymentScreen from './PaymentScreen';
import PaypalScreen from './PaypalScreen'

export const PAYMENT_ROUTE = "/payment";
export const PAYMENT_SUBSCRIPTION_ROUTE = PAYMENT_ROUTE + "/subscription/:userId";
export const PAYMENT_PAYPAL_ROUTE = "/paypal/subscription/:userId";
export const LEAGUE_PASS_PAYMENT_ROUTE = '/paypal/:paymentType/:userId';

export const routes = [
    {
        path: PAYMENT_SUBSCRIPTION_ROUTE,
        component: PaymentScreen,
        public: true,
        exact: true
    },
    {
        path: PAYMENT_PAYPAL_ROUTE,
        component: PaypalScreen,
        public: true,
        exact: true
    },
    {
        path: LEAGUE_PASS_PAYMENT_ROUTE,
        component: PaypalScreen,
        public: true,
        exact: true
    },
]


